/**
 *  Application
 *
 *  Created by Legman on 04/09/2015.
 *
 */

import CharacterScene from "./scenes/CharacterScene";
import ConfirmQuitScene from "./scenes/ConfirmQuitScene";
import Common from "./Common";
import GameScene from "./scenes/GameScene";
import PauseScene from "./scenes/PauseScene";
import ResultsScene from "./scenes/ResultsScene";
import SplashScene from "./scenes/SplashScene";
import ThemeLoaderScene from "./scenes/ThemeLoaderScene";

export default class Application {
    constructor() {
        /**
         * @type {PIXI.Sprite}
         * @private
         */
        this._overlay = null;
    }

    /**
     */
    init() {
        this.showSplashScene();
    }

    /**
     * @param {p3.Transition} [transition]
     * @returns {p3.Scene}
     */
    showSplashScene(transition) {
        Common.paused = false;

        const scene = new SplashScene();
        scene.signals.next.add(function() {
            this.showCharacterScene();
        }, this);

        transition = transition || new p3.FadeTransition();
        Common.scene.add(scene, transition);
        return scene;
    }

    /**
     * @param {p3.Transition} [transition]
     * @returns {p3.Scene}
     */
    showCharacterScene(transition) {
        const scene = new CharacterScene();
        scene.signals.next.add(function(scene, id) {
            Common.playerDriverId = id;

            this.showThemeLoaderScene();
        }, this);
        scene.signals.home.add(function() {
            this.showSplashScene();
        }, this);

        transition = transition || new p3.FadeTransition();
        Common.scene.add(scene, transition);
        return scene;
    }

    /**
     * @param {p3.Transition} [transition]
     * @returns {ThemeLoaderScene}
     */
    showThemeLoaderScene(transition) {
        const scene = new ThemeLoaderScene();
        scene.signals.next.add(function(scene) {
            this.showGameScene(Common.isFirstTime);
        }, this);

        transition = transition || new p3.FadeTransition();
        Common.scene.add(scene, transition);
        return scene;
    }

    /**
     * @param {boolean} [tutorial]
     * @param {boolean} [replay]
     * @param {p3.Transition} [transition]
     * @returns {p3.Scene}
     */
    showGameScene(tutorial, replay, transition) {
        Common.paused = false;

        const scene = new GameScene(tutorial, replay);
        scene.signals.next.add(function(scene, place) {
            this.showResultsScene(Common.playerDriverId, place);
        }, this);
        scene.signals.pause.add(function() {
            scene.pauseGame();
            this.showOverlay(true);

            this.showPauseScene();
        }, this);

        transition = transition || new p3.FadeTransition();
        Common.scene.add(scene, transition);
        return scene;
    }

    /**
     * @param {p3.Transition} [transition]
     * @returns {p3.Scene}
     */
    showPauseScene(transition) {
        Common.paused = true;

        const scene = new PauseScene();
        scene.signals.home.add(function() {
            this.showConfirmQuitScene();
        }, this);
        scene.signals.next.add(function() {
            Common.paused = false;
            this.hideOverlay(true);

            Common.scene.remove();
        }, this);
        scene.signals.previous.add(function(scene) {
            this.showGameScene();
        }, this);

        if (!transition) {
            transition = new p3.Transition();
            transition.push = true;
            transition.replace = false;
        }
        Common.scene.add(scene, transition);
        return scene;
    }

    /**
     * @param {p3.Transition} [transition]
     * @returns {p3.Scene}
     */
    showConfirmQuitScene(transition) {
        const scene = new ConfirmQuitScene();
        scene.signals.next.add(function() {
            this.showSplashScene();
        }, this);
        scene.signals.previous.add(function() {
            Common.scene.remove();
        }, this);

        if (!transition) {
            transition = new p3.Transition();
            transition.push = true;
            transition.replace = true;
        }
        Common.scene.add(scene, transition);
        return scene;
    }

    /**
     * @param {number} [id]
     * @param {number} [place]
     * @param {p3.Transition} [transition]
     * @returns {ResultsScene}
     */
    showResultsScene(id, place, transition) {
        const scene = new ResultsScene(id, place);
        scene.signals.home.add(function() {
            this.showSplashScene();
        }, this);
        scene.signals.next.add(function() {
            this.showCharacterScene();
        }, this);
        scene.signals.previous.add(function() {
            this.showGameScene(false, true);
        }, this);

        transition = transition || new p3.FadeTransition();
        Common.scene.add(scene, transition);
        return scene;
    }

    /**
     * @param {boolean} [animate]
     * @param {function} [callback]
     * @param {*} [scope]
     */
    showOverlay(animate, callback, scope) {
        this.hideOverlay();

        this._overlay = new PIXI.Sprite(Common.blankTexture);
        this._overlay.width = p3.View.width;
        this._overlay.height = p3.View.height;
        this._overlay.tint = 0x281186;
        Common.scene.view.addChild(this._overlay);

        if (animate) {
            this._overlay.alpha = 0;
            TweenMax.to(this._overlay, 0.2, {
                alpha: 0.6,
                ease: Power1.easeInOut,
                onComplete: callback,
                onCompleteScope: scope
            });
        } else {
            this._overlay.alpha = 0.6;
        }
    }

    /**
     * @param {boolean} [animate]
     * @param {function} [callback]
     * @param {*} [scope]
     */
    hideOverlay(animate, callback, scope) {
        if (!this._overlay) return;

        if (animate) {
            TweenMax.to(this._overlay, 0.2, {
                alpha: 0,
                ease: Power1.easeInOut,
                onComplete: function() {
                    this._overlay.parent.removeChild(this._overlay);
                    this._overlay.destroy();
                    this._overlay = null;

                    callback && callback.call(scope);
                },
                onCompleteScope: this
            });
        } else {
            this._overlay.parent.removeChild(this._overlay);
            this._overlay.destroy();
            this._overlay = null;
        }
    }
}
